"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractiveStreamForm = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUseFormState = require("react-use-form-state");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
var _Button = require("../../Button");
var _PhotoInput = require("../../PhotoInput");
var _DatePicker = require("../../DatePicker");
var _TimePicker = require("../../TimePicker");
var _InteractiveStreamForm = require("./InteractiveStreamForm.styled");
var _helpers = require("../../../helpers");
var _constants = require("../../../constants");
var _StreamSourceSelect = require("../StreamSourceSelect");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var InteractiveStreamForm = exports.InteractiveStreamForm = function InteractiveStreamForm(_ref) {
  var onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    streamDetails = _ref.streamDetails,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'MM-DD-YYYY' : _ref$dateFormat;
  var savedFeaturedImageId = streamDetails && streamDetails.theme ? streamDetails.theme.featuredImage : undefined;
  var showPasswordInput = streamDetails && streamDetails.authentication && streamDetails.authentication.password !== '';
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = (0, _react.useState)(savedFeaturedImageId),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    featuredImage = _useState4[0],
    setFeaturedImage = _useState4[1];
  var _useState5 = (0, _react.useState)(showPasswordInput),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isPasswordProtected = _useState6[0],
    setIsPasswordProtected = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    showPassword = _useState8[0],
    setShowPassword = _useState8[1];
  var defaultDate = _moment["default"].utc().startOf('day').format(dateFormat);
  var defaultTime = _moment["default"].utc().startOf('day').add(9, 'hours');
  var togglePasswordIcon = showPassword ? _freeSolidSvgIcons.faEyeSlash : _freeSolidSvgIcons.faEye;
  var inputType = showPassword ? 'text' : 'password';
  var buttonText = {
    notSubmitting: 'Save',
    submitting: 'Saving...'
  };
  var savedFeaturedImageUrl = streamDetails && streamDetails.theme ? streamDetails.theme.featuredImageUrl : null;
  var isEditing = streamDetails && streamDetails.title !== '';

  // initial values
  var streamTitle = '',
    streamDescription = '',
    streamStartOn = defaultTime,
    streamEndOn = defaultTime,
    streamingDate = defaultDate,
    streamSource = _constants.BROADCAST_SOURCE_TYPE,
    streamEmbedCode = '',
    password = '';
  if (streamDetails) {
    streamTitle = streamDetails.title;
    streamDescription = streamDetails.description;
    if (streamDetails.authentication) {
      password = streamDetails.authentication.password;
    }
    streamStartOn = (0, _moment["default"])(streamDetails.startOn);
    streamEndOn = (0, _moment["default"])(streamDetails.endOn);
    streamingDate = (0, _moment["default"])(streamDetails.startOn).format(dateFormat);
    streamSource = streamDetails.sourceType;
    streamEmbedCode = streamDetails.embedCode;
  }
  var _useState9 = (0, _react.useState)(streamDescription),
    _useState0 = (0, _slicedToArray2["default"])(_useState9, 2),
    description = _useState0[0],
    setDescription = _useState0[1];
  var _useState1 = (0, _react.useState)(streamStartOn.utc().format('HH:mm:ss')),
    _useState10 = (0, _slicedToArray2["default"])(_useState1, 2),
    startOnTime = _useState10[0],
    setStartOnTime = _useState10[1];
  var _useState11 = (0, _react.useState)(streamEndOn.utc().format('HH:mm:ss')),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    endOnTime = _useState12[0],
    setEndOnTime = _useState12[1];
  var _useState13 = (0, _react.useState)(streamingDate),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    startOnDate = _useState14[0],
    setStartOnDate = _useState14[1];
  var _useFormState = (0, _reactUseFormState.useFormState)({
      title: streamTitle,
      featuredImage: featuredImage,
      passwordProtected: isPasswordProtected,
      password: password
    }),
    _useFormState2 = (0, _slicedToArray2["default"])(_useFormState, 2),
    formState = _useFormState2[0],
    text = _useFormState2[1].text;
  var passwordInvalid = formState.touched.password && !formState.validity.password;
  var _useState15 = (0, _react.useState)(streamSource),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    sourceType = _useState16[0],
    setSourceType = _useState16[1];
  var _useState17 = (0, _react.useState)(streamEmbedCode),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    embedCode = _useState18[0],
    setEmbedCode = _useState18[1];
  var onFormSubmit = function onFormSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);
    var _splitTimeString = (0, _helpers.splitTimeString)(startOnTime),
      _splitTimeString2 = (0, _slicedToArray2["default"])(_splitTimeString, 2),
      startHours = _splitTimeString2[0],
      startMinutes = _splitTimeString2[1];
    var _splitTimeString3 = (0, _helpers.splitTimeString)(endOnTime),
      _splitTimeString4 = (0, _slicedToArray2["default"])(_splitTimeString3, 2),
      endHours = _splitTimeString4[0],
      endMinutes = _splitTimeString4[1];
    var startTime = (0, _helpers.addTimeToDate)(startOnDate, dateFormat, startHours, startMinutes);
    var endTime = (0, _helpers.addTimeToDate)(startOnDate, dateFormat, endHours, endMinutes);
    var interactiveStream = {
      title: formState.values.title,
      description: description,
      startOn: startTime,
      endOn: endTime,
      authentication: {
        type: isPasswordProtected ? 'password' : 'none',
        password: formState.values.password
      },
      theme: {
        featuredImage: featuredImage
      },
      embedCode: embedCode,
      sourceType: sourceType
    };
    onSubmit(interactiveStream);
  };
  var onPasswordProtection = function onPasswordProtection() {
    setIsPasswordProtected(!isPasswordProtected);
  };
  var onTogglePassword = function onTogglePassword() {
    setShowPassword(!showPassword);
  };
  var onDescriptionChange = function onDescriptionChange(e) {
    setDescription(e.target.value);
  };
  var onDateChange = function onDateChange(date) {
    if (date) {
      setStartOnDate((0, _moment["default"])(date).format(dateFormat));
    } else {
      setStartOnDate(defaultDate);
    }
  };

  /**
   *
   * @param {boolean} isStartOn Specifies whether we're setting start time or end time
   * @param {{}} time Instance of momment object
   */
  var onTimeChange = function onTimeChange(isStartOn, time) {
    var formattedTime = _moment["default"].utc(time).format('HH:mm:[00]');
    if (isStartOn) {
      setStartOnTime(formattedTime);
    } else {
      setEndOnTime(formattedTime);
    }
  };
  var saveButtonDisabled = function saveButtonDisabled() {
    return !formIsValid(formState, isPasswordProtected, isEditing) || isSubmitting;
  };
  var onSourceTypeChange = function onSourceTypeChange(source) {
    setSourceType(source);
  };
  var isTitleInvalid = function isTitleInvalid() {
    return formState.touched.title && !formState.values.title;
  };
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Form, {
    "data-testid": "stream-form",
    onSubmit: onFormSubmit
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledSubHeader, null, "Add a new theater to your event. Theater\u2019s can receive a stream from a Shoflo Studio, an external RTMP/S stream, or from an embedded third party player such as Vimeo or Youtube.")), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, {
    id: "stream-title-label",
    htmlFor: "stream-title"
  }, "Theater title"), /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledCaption, null, "Title of your theater that attendees will see."), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({
    "data-testid": "stream-title",
    id: "stream-title",
    "aria-labelledby": "stream-title-label",
    placeholder: "e.g. Morning Session"
  }, text({
    name: 'title',
    validate: function validate(t) {
      return t.length >= 1;
    },
    validateOnBlur: false,
    touchOnChange: true
  }), {
    invalid: isTitleInvalid(),
    required: true
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormFeedback, null, "Uh oh! A title is required.")), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, {
    id: "strem-description-label",
    htmlFor: "stream-description"
  }, "Theater description"), /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledCaption, null, "Describe the general topic or theme of your theater. This will be visible by attendees on your theater landing page."), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
    type: "textarea",
    "data-testid": "stream-description",
    id: "stream-description",
    "aria-labelledby": "strem-description-label",
    placeholder: "e.g. Welcome to Global Summit 2020...",
    value: description,
    onChange: onDescriptionChange
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, {
    form: true
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 4
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, {
    id: "stream-start-date-label",
    htmlFor: "stream-start-date"
  }, "Start Date"), /*#__PURE__*/_react["default"].createElement(_DatePicker.DatePicker, {
    id: "stream-start-date",
    format: dateFormat,
    title: "Start Date",
    value: startOnDate,
    onChange: onDateChange,
    disablePastDates: true,
    dataTestId: "stream-start-date",
    "aria-labelledby": "stream-start-date-label"
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 4
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, {
    id: "stream-start-time-label",
    htmlFor: "stream-start-time"
  }, "Start Time"), /*#__PURE__*/_react["default"].createElement(_TimePicker.TimePicker, {
    id: "stream-start-time",
    dataTestId: "stream-start-time",
    showSecond: false,
    defaultValue: _moment["default"].utc(startOnTime, 'HH:mm'),
    onChange: onTimeChange.bind(null, true),
    format: 'h:mm a',
    placeholder: _moment["default"].utc().hours(9).format('h:mm a'),
    use12Hours: true,
    "aria-labelledby": "stream-start-time-label"
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 4
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, {
    id: "stream-end-time-label",
    htmlFor: "stream-end-time"
  }, "End Time"), /*#__PURE__*/_react["default"].createElement(_TimePicker.TimePicker, {
    id: "stream-end-time",
    dataTestId: "stream-end-time",
    showSecond: false,
    defaultValue: _moment["default"].utc(endOnTime, 'HH:mm'),
    onChange: onTimeChange.bind(null, false),
    format: 'h:mm a',
    placeholder: _moment["default"].utc().hours(9).format('h:mm a'),
    use12Hours: true,
    "aria-labelledby": "stream-end-time-label"
  })))), /*#__PURE__*/_react["default"].createElement(_StreamSourceSelect.StreamSourceSelect, {
    onSourceTypeChange: onSourceTypeChange,
    sourceType: sourceType,
    onEmbedCodeChange: function onEmbedCodeChange(value) {
      return setEmbedCode(value);
    },
    embedCode: embedCode
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_PhotoInput.PhotoInput, {
    id: "featured-image",
    caption: "Featured image",
    imageUri: savedFeaturedImageUrl || featuredImage,
    onChange: setFeaturedImage,
    description: "Shows when stream player is not yet live.",
    dataTestId: "featured-image"
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, null, "Link password"), /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledCaption, null, "Require a password to view the theater.")), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.ToggleSwitchWrapper, {
    htmlFor: "toggle-password-protection"
  }, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledToggleSwitch, {
    on: isPasswordProtected,
    onClick: onPasswordProtection,
    id: "toggle-password-protection",
    "data-testid": "toggle-password-protection"
  }), "Password protected")), isPasswordProtected && /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledFormLabel, {
    id: "stream-password-label",
    htmlFor: "stream-password"
  }, "Password"), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.PasswordWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({}, text({
    name: 'password',
    validateOnBlur: false,
    validate: function validate(t) {
      var isValid = t.length >= 1;
      return isValid;
    },
    touchOnChange: true
  }), {
    id: "stream-assword",
    placeholder: "Password",
    "aria-labelledby": "stream-password-label",
    type: inputType,
    invalid: passwordInvalid,
    required: true,
    "data-testid": "stream-password"
  })), /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.TogglePasswordButton, {
    onClick: onTogglePassword,
    role: "toggle-password",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    alt: "toggle password",
    icon: togglePasswordIcon
  }))), passwordInvalid && /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledErrorMessage, null, "Uh oh! A password is required.")))))), /*#__PURE__*/_react["default"].createElement(_InteractiveStreamForm.StyledModalFooter, {
    className: "float-end modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    "data-testid": "stream-save-button",
    color: "primary",
    disabled: saveButtonDisabled() && !isEditing
  }, isSubmitting ? buttonText.submitting : buttonText.notSubmitting), ' ', /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    "data-testid": "stream-cancel-button",
    color: "light",
    variant: "ghost",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    }
  }, "Cancel")));
};

/**
 *
 * @param {{}} formState
 * @param {boolean} isPasswordProtected
 * @param {boolean} isEditing
 */
function formIsValid(formState, isPasswordProtected, isEditing) {
  if (isPasswordProtected && !isEditing) return formState.validity.title && formState.validity.password;
  if (!isPasswordProtected && !isEditing) return formState.validity.title;
  if (isPasswordProtected && isEditing) return formState.validity.title || formState.validity.password;
  if (!isPasswordProtected && isEditing) return formState.validity.title;
}
InteractiveStreamForm.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  streamDetails: _propTypes["default"].object
};
InteractiveStreamForm.defaultProps = {
  streamDetails: null
};